import deepSignApi from '@/api/deepsign/deepsignApi';
import type { AxiosRequestConfig } from 'axios';
import type { SigneeGroup } from '@/types/deepsign/SigneeGroup';
import type { SigneeGroupUpdate } from '@/types/deepsign/SigneeGroupUpdate';

//TODO @daniel.henkiel missing api definition - not yet part of @deepcloud/api-deep-sign
/**
 * Update a signee group's quorum (requiredSignatures / requiredApprovals).
 *
 * `PUT /api/v1/documents/{documentId}/signee-groups/{signeeGroupId}`
 *
 * Notes:
 * - Only allowed while the document has status `draft`.
 * - A `null` value means every member of the group must sign / approve.
 *
 * @param documentId The document (envelope) the signee group belongs to
 * @param signeeGroupId The signee group to update
 * @param data The quorum values to set
 * @param config Optional axios request config
 */
export const updateSigneeGroup = (
  documentId: string,
  signeeGroupId: string,
  data: SigneeGroupUpdate,
  config?: AxiosRequestConfig
) =>
  deepSignApi.put<SigneeGroup>(
    `documents/${documentId}/signee-groups/${signeeGroupId}`,
    data,
    config
  );
